import React, {Component} from 'react';
import {FormControl} from "react-bootstrap";
import Validator from "../../../../../utilities/Validator";


export default class DefinicjaGodzinyStartowejInputZmiana extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error:false,
        };
        this.onChangeZmiana=this.onChangeZmiana.bind(this)
    }

    onChangeZmiana(e) {
        if (Boolean(e)) {
            let zmiana = e.target.value
            if(Validator.validateInt(zmiana)){
                this.setState({error:false})
                this.props.handleChangeZmiana(zmiana,this.props.rekord)
            }else this.setState({error:true})

        } else this.setState({error:true})
    }

    render() {

        return (
            <div className={this.state.error? 'has-error':''}>
                <FormControl type={'number'} onChange={this.onChangeZmiana} defaultValue={Boolean(this.props.obecnaZmiana)? this.props.obecnaZmiana : ''}/>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/definicjeGodzinStartowychjDlaTrasy/components/DefinicjaGodzinyStartowejInputZmiana.js